import product1 from "../images/product1_firstpage.png";
import product2 from "../images/product2.jpg";
import product3 from "../images/product3.jpg";
import product4 from "../images/product7.jpg";
import product5 from "../images/product8.jpg";
import default_firstpage from "../images/product1_firstpage.png";

//import { apiKey } from "../config";
//const url = `https://watchmode.p.rapidapi.com/sources/?apiKey=${apiKey}&limit=${limit}`;
// return fetch(url);

const allProducts = [
  
];

export default allProducts;
